module.exports = __webpack_public_path__ + "img/download_appleTW.c6fa0540.png";